import {getFetchedJSON, fetchWithStateTL} from '~/misc/fetch';

export const creditCardInfoApi = (getState, val) => fetchWithStateTL(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: `/${val.account_id}/card-list`,
}).then(getFetchedJSON);

export const setDefaultCardApi = (getState, val) => fetchWithStateTL(getState, {
  method: 'POST',
  url: `/${val.account_id}/card/default`,
  body: val,
}).then(getFetchedJSON);

export const deleteCardApi = (getState, val) => fetchWithStateTL(getState, {
  method: 'DELETE',
  url: `/${val.account_id}/card`,
  body: val,
}).then(getFetchedJSON);

export const addCardApi = (getState, val) => fetchWithStateTL(getState, {
  method: 'POST',
  url: `/${val.account_id}/card`,
  body: val,
}).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/paymentSettingPage/api.js